export const FETCH_CATEGORIES_FAILURE =
	'state.actions.fetch-categories-failure.FETCH_CATEGORIES_FAILURE' as const;

export type FetchCategoriesFailurePayload = {
	statusCode: number;
};

export type FetchCategoriesFailureAction = {
	type: typeof FETCH_CATEGORIES_FAILURE;
	payload: FetchCategoriesFailurePayload;
};

export const fetchCategoriesFailure = (
	error: FetchCategoriesFailurePayload,
): FetchCategoriesFailureAction => ({
	type: FETCH_CATEGORIES_FAILURE,
	payload: error,
});
